import httpService from './httpService'
async function add(serialNo, data) {
  return httpService.apiRequest('post', `/profile/device/${serialNo}/extension`, data)
}

async function deleteExtension(serialNo, extensionId) {
  return httpService.apiRequest('delete', `/profile/device/${serialNo}/extension/${extensionId}`)
}

async function activate(serialNo, extensionId) {
  return httpService.apiRequest('patch', `/profile/device/${serialNo}/extension/${extensionId}/activate`)
}

async function deactivate(serialNo, extensionId) {
  return httpService.apiRequest('patch', `/profile/device/${serialNo}/extension/${extensionId}/deactivate`)
}

async function getByDevice(serialNo) {
  return httpService.apiRequest('get', `/profile/device/${serialNo}/extensions?onlyService=true`)
}

async function updateById(extensionId, data) {
  return httpService.apiRequest('patch', `/profile/extension/${extensionId}`, data)
}

export default {
  add,
  deleteExtension,
  activate,
  deactivate,
  getByDevice,
  updateById
}



// WEBPACK FOOTER //
// ./src/services/extensionService.js